var it = Object.defineProperty;
var at = (t, n, e) => n in t ? it(t, n, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: e
}) : t[n] = e;
var re = (t, n, e) => (at(t, typeof n != "symbol" ? n + "" : n, e), e);
var ke = class {
    static error(n, ...e) {
      console.trace("%c" + n, this.styleError, ...e)
    }
    static info(n, ...e) {
      console.info("%c" + n, this.styleSubdued, ...e)
    }
    static log(n, ...e) {
      console.log("%c" + n, this.styleBold, ...e)
    }
  },
  ie = ke;
re(ie, "NAME", "Logger"), re(ie, "styleBold", ["color: white", "font-weight: bold"].join(";")), re(ie, "styleError", ["color: red", "text-align: left"].join(";")), re(ie, "styleSubdued", ["color: gray", "font-weight: normal"].join(";")), (() => {
  ke.info(`${ke.NAME} > init`)
})();
var R = ie;

function st(t, n) {
  if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function")
}

function Oe(t, n) {
  for (var e = 0; e < n.length; e++) {
    var o = n[e];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o)
  }
}

function ct(t, n, e) {
  return n && Oe(t.prototype, n), e && Oe(t, e), t
}
var je = typeof global < "u" && {}.toString.call(global) === "[object global]";

function ze(t, n) {
  return t.indexOf(n.toLowerCase()) === 0 ? t : "".concat(n.toLowerCase()).concat(t.substr(0, 1).toUpperCase()).concat(t.substr(1))
}

function lt(t) {
  return Boolean(t && t.nodeType === 1 && "nodeName" in t && t.ownerDocument && t.ownerDocument.defaultView)
}

function ut(t) {
  return !isNaN(parseFloat(t)) && isFinite(t) && Math.floor(t) == t
}

function ae(t) {
  return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(t)
}

function We(t) {
  var n = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
  return n.test(t)
}

function Ue() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
    n = t.id,
    e = t.url,
    o = n || e;
  if (!o) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (ut(o)) return "https://vimeo.com/".concat(o);
  if (ae(o)) return o.replace("http:", "https:");
  throw n ? new TypeError("\u201C".concat(n, "\u201D is not a valid video id.")) : new TypeError("\u201C".concat(o, "\u201D is not a vimeo.com url."))
}
var dt = typeof Array.prototype.indexOf < "u",
  ft = typeof window < "u" && typeof window.postMessage < "u";
if (!je && (!dt || !ft)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var ue = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};

function mt(t, n) {
  return n = {
    exports: {}
  }, t(n, n.exports), n.exports
}(function (t) {
  if (t.WeakMap) return;
  var n = Object.prototype.hasOwnProperty,
    e = Object.defineProperty && function () {
      try {
        return Object.defineProperty({}, "x", {
          value: 1
        }).x === 1
      } catch {}
    }(),
    o = function (a, i, l) {
      e ? Object.defineProperty(a, i, {
        configurable: !0,
        writable: !0,
        value: l
      }) : a[i] = l
    };
  t.WeakMap = function () {
    function a() {
      if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
      if (o(this, "_id", l("_WeakMap")), arguments.length > 0) throw new TypeError("WeakMap iterable is not supported")
    }
    o(a.prototype, "delete", function (s) {
      if (i(this, "delete"), !r(s)) return !1;
      var y = s[this._id];
      return y && y[0] === s ? (delete s[this._id], !0) : !1
    }), o(a.prototype, "get", function (s) {
      if (i(this, "get"), !!r(s)) {
        var y = s[this._id];
        if (y && y[0] === s) return y[1]
      }
    }), o(a.prototype, "has", function (s) {
      if (i(this, "has"), !r(s)) return !1;
      var y = s[this._id];
      return !!(y && y[0] === s)
    }), o(a.prototype, "set", function (s, y) {
      if (i(this, "set"), !r(s)) throw new TypeError("Invalid value used as weak map key");
      var b = s[this._id];
      return b && b[0] === s ? (b[1] = y, this) : (o(s, this._id, [s, y]), this)
    });

    function i(s, y) {
      if (!r(s) || !n.call(s, "_id")) throw new TypeError(y + " method called on incompatible receiver " + typeof s)
    }

    function l(s) {
      return s + "_" + d() + "." + d()
    }

    function d() {
      return Math.random().toString().substring(2)
    }
    return o(a, "_polyfill", !0), a
  }();

  function r(a) {
    return Object(a) === a
  }
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : ue);
var ne = mt(function (t) {
    (function (e, o, r) {
      o[e] = o[e] || r(), t.exports && (t.exports = o[e])
    })("Promise", ue, function () {
      var e, o, r, a = Object.prototype.toString,
        i = typeof setImmediate < "u" ? function (u) {
          return setImmediate(u)
        } : setTimeout;
      try {
        Object.defineProperty({}, "x", {}), e = function (u, f, E, k) {
          return Object.defineProperty(u, f, {
            value: E,
            writable: !0,
            configurable: k !== !1
          })
        }
      } catch {
        e = function (f, E, k) {
          return f[E] = k, f
        }
      }
      r = function () {
        var u, f, E;

        function k(P, g) {
          this.fn = P, this.self = g, this.next = void 0
        }
        return {
          add: function (g, L) {
            E = new k(g, L), f ? f.next = E : u = E, f = E, E = void 0
          },
          drain: function () {
            var g = u;
            for (u = f = o = void 0; g;) g.fn.call(g.self), g = g.next
          }
        }
      }();

      function l(c, u) {
        r.add(c, u), o || (o = i(r.drain))
      }

      function d(c) {
        var u, f = typeof c;
        return c != null && (f == "object" || f == "function") && (u = c.then), typeof u == "function" ? u : !1
      }

      function s() {
        for (var c = 0; c < this.chain.length; c++) y(this, this.state === 1 ? this.chain[c].success : this.chain[c].failure, this.chain[c]);
        this.chain.length = 0
      }

      function y(c, u, f) {
        var E, k;
        try {
          u === !1 ? f.reject(c.msg) : (u === !0 ? E = c.msg : E = u.call(void 0, c.msg), E === f.promise ? f.reject(TypeError("Promise-chain cycle")) : (k = d(E)) ? k.call(E, f.resolve, f.reject) : f.resolve(E))
        } catch (P) {
          f.reject(P)
        }
      }

      function b(c) {
        var u, f = this;
        if (!f.triggered) {
          f.triggered = !0, f.def && (f = f.def);
          try {
            (u = d(c)) ? l(function () {
              var E = new _(f);
              try {
                u.call(c, function () {
                  b.apply(E, arguments)
                }, function () {
                  v.apply(E, arguments)
                })
              } catch (k) {
                v.call(E, k)
              }
            }): (f.msg = c, f.state = 1, f.chain.length > 0 && l(s, f))
          } catch (E) {
            v.call(new _(f), E)
          }
        }
      }

      function v(c) {
        var u = this;
        u.triggered || (u.triggered = !0, u.def && (u = u.def), u.msg = c, u.state = 2, u.chain.length > 0 && l(s, u))
      }

      function C(c, u, f, E) {
        for (var k = 0; k < u.length; k++)(function (g) {
          c.resolve(u[g]).then(function (D) {
            f(g, D)
          }, E)
        })(k)
      }

      function _(c) {
        this.def = c, this.triggered = !1
      }

      function m(c) {
        this.promise = c, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0
      }

      function w(c) {
        if (typeof c != "function") throw TypeError("Not a function");
        if (this.__NPO__ !== 0) throw TypeError("Not a promise");
        this.__NPO__ = 1;
        var u = new m(this);
        this.then = function (E, k) {
          var P = {
            success: typeof E == "function" ? E : !0,
            failure: typeof k == "function" ? k : !1
          };
          return P.promise = new this.constructor(function (L, D) {
            if (typeof L != "function" || typeof D != "function") throw TypeError("Not a function");
            P.resolve = L, P.reject = D
          }), u.chain.push(P), u.state !== 0 && l(s, u), P.promise
        }, this.catch = function (E) {
          return this.then(void 0, E)
        };
        try {
          c.call(void 0, function (E) {
            b.call(u, E)
          }, function (E) {
            v.call(u, E)
          })
        } catch (f) {
          v.call(u, f)
        }
      }
      var p = e({}, "constructor", w, !1);
      return w.prototype = p, e(p, "__NPO__", 0, !1), e(w, "resolve", function (u) {
        var f = this;
        return u && typeof u == "object" && u.__NPO__ === 1 ? u : new f(function (k, P) {
          if (typeof k != "function" || typeof P != "function") throw TypeError("Not a function");
          k(u)
        })
      }), e(w, "reject", function (u) {
        return new this(function (E, k) {
          if (typeof E != "function" || typeof k != "function") throw TypeError("Not a function");
          k(u)
        })
      }), e(w, "all", function (u) {
        var f = this;
        return a.call(u) != "[object Array]" ? f.reject(TypeError("Not an array")) : u.length === 0 ? f.resolve([]) : new f(function (k, P) {
          if (typeof k != "function" || typeof P != "function") throw TypeError("Not a function");
          var g = u.length,
            L = Array(g),
            D = 0;
          C(f, u, function (W, q) {
            L[W] = q, ++D === g && k(L)
          }, P)
        })
      }), e(w, "race", function (u) {
        var f = this;
        return a.call(u) != "[object Array]" ? f.reject(TypeError("Not an array")) : new f(function (k, P) {
          if (typeof k != "function" || typeof P != "function") throw TypeError("Not a function");
          C(f, u, function (L, D) {
            k(D)
          }, P)
        })
      }), w
    })
  }),
  Z = new WeakMap;

function pe(t, n, e) {
  var o = Z.get(t.element) || {};
  n in o || (o[n] = []), o[n].push(e), Z.set(t.element, o)
}

function Se(t, n) {
  var e = Z.get(t.element) || {};
  return e[n] || []
}

function Ce(t, n, e) {
  var o = Z.get(t.element) || {};
  if (!o[n]) return !0;
  if (!e) return o[n] = [], Z.set(t.element, o), !0;
  var r = o[n].indexOf(e);
  return r !== -1 && o[n].splice(r, 1), Z.set(t.element, o), o[n] && o[n].length === 0
}

function pt(t, n) {
  var e = Se(t, n);
  if (e.length < 1) return !1;
  var o = e.shift();
  return Ce(t, n, o), o
}

function ht(t, n) {
  var e = Z.get(t);
  Z.set(n, e), Z.delete(t)
}

function Pe(t) {
  if (typeof t == "string") try {
    t = JSON.parse(t)
  } catch (n) {
    return console.warn(n), {}
  }
  return t
}

function he(t, n, e) {
  if (!(!t.element.contentWindow || !t.element.contentWindow.postMessage)) {
    var o = {
      method: n
    };
    e !== void 0 && (o.value = e);
    var r = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    r >= 8 && r < 10 && (o = JSON.stringify(o)), t.element.contentWindow.postMessage(o, t.origin)
  }
}

function vt(t, n) {
  n = Pe(n);
  var e = [],
    o;
  if (n.event) {
    if (n.event === "error") {
      var r = Se(t, n.data.method);
      r.forEach(function (i) {
        var l = new Error(n.data.message);
        l.name = n.data.name, i.reject(l), Ce(t, n.data.method, i)
      })
    }
    e = Se(t, "event:".concat(n.event)), o = n.data
  } else if (n.method) {
    var a = pt(t, n.method);
    a && (e.push(a), o = n.value)
  }
  e.forEach(function (i) {
    try {
      if (typeof i == "function") {
        i.call(t, o);
        return
      }
      i.resolve(o)
    } catch {}
  })
}
var gt = ["autopause", "autoplay", "background", "byline", "color", "controls", "dnt", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "playsinline", "portrait", "responsive", "speed", "texttrack", "title", "transparent", "url", "width"];

function He(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return gt.reduce(function (e, o) {
    var r = t.getAttribute("data-vimeo-".concat(o));
    return (r || r === "") && (e[o] = r === "" ? 1 : r), e
  }, n)
}

function qe(t, n) {
  var e = t.html;
  if (!n) throw new TypeError("An element must be provided");
  if (n.getAttribute("data-vimeo-initialized") !== null) return n.querySelector("iframe");
  var o = document.createElement("div");
  return o.innerHTML = e, n.appendChild(o.firstChild), n.setAttribute("data-vimeo-initialized", "true"), n.querySelector("iframe")
}

function Qe(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
    e = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function (o, r) {
    if (!ae(t)) throw new TypeError("\u201C".concat(t, "\u201D is not a vimeo.com url."));
    var a = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(t));
    for (var i in n) n.hasOwnProperty(i) && (a += "&".concat(i, "=").concat(encodeURIComponent(n[i])));
    var l = "XDomainRequest" in window ? new XDomainRequest : new XMLHttpRequest;
    l.open("GET", a, !0), l.onload = function () {
      if (l.status === 404) {
        r(new Error("\u201C".concat(t, "\u201D was not found.")));
        return
      }
      if (l.status === 403) {
        r(new Error("\u201C".concat(t, "\u201D is not embeddable.")));
        return
      }
      try {
        var d = JSON.parse(l.responseText);
        if (d.domain_status_code === 403) {
          qe(d, e), r(new Error("\u201C".concat(t, "\u201D is not embeddable.")));
          return
        }
        o(d)
      } catch (s) {
        r(s)
      }
    }, l.onerror = function () {
      var d = l.status ? " (".concat(l.status, ")") : "";
      r(new Error("There was an error fetching the embed code from Vimeo".concat(d, ".")))
    }, l.send()
  })
}

function yt() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document,
    n = [].slice.call(t.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")),
    e = function (r) {
      "console" in window && console.error && console.error("There was an error creating an embed: ".concat(r))
    };
  n.forEach(function (o) {
    try {
      if (o.getAttribute("data-vimeo-defer") !== null) return;
      var r = He(o),
        a = Ue(r);
      Qe(a, r, o).then(function (i) {
        return qe(i, o)
      }).catch(e)
    } catch (i) {
      e(i)
    }
  })
}

function bt() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var n = function (o) {
      if (!!ae(o.origin) && !(!o.data || o.data.event !== "spacechange")) {
        for (var r = t.querySelectorAll("iframe"), a = 0; a < r.length; a++)
          if (r[a].contentWindow === o.source) {
            var i = r[a].parentElement;
            i.style.paddingBottom = "".concat(o.data.data[0].bottom, "px");
            break
          }
      }
    };
    window.addEventListener("message", n)
  }
}

function wt() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var n = function (o) {
      if (!!ae(o.origin)) {
        var r = Pe(o.data);
        if (!(!r || r.event !== "ready"))
          for (var a = t.querySelectorAll("iframe"), i = 0; i < a.length; i++) {
            var l = a[i],
              d = l.contentWindow === o.source;
            if (We(l.src) && d) {
              var s = new Ie(l);
              s.callMethod("appendVideoMetadata", window.location.href)
            }
          }
      }
    };
    window.addEventListener("message", n)
  }
}

function _t() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var n = function (r) {
        "console" in window && console.error && console.error("There was an error getting video Id: ".concat(r))
      },
      e = function (r) {
        if (!!ae(r.origin)) {
          var a = Pe(r.data);
          if (!(!a || a.event !== "ready"))
            for (var i = t.querySelectorAll("iframe"), l = 0; l < i.length; l++) {
              var d = i[l],
                s = d.contentWindow === r.source;
              We(d.src) && s && function () {
                var y = new Ie(d);
                y.getVideoId().then(function (b) {
                  var v = new RegExp("[?&]vimeo_t_".concat(b, "=([^&#]*)")).exec(window.location.href);
                  if (v && v[1]) {
                    var C = decodeURI(v[1]);
                    y.setCurrentTime(C)
                  }
                }).catch(n)
              }()
            }
        }
      };
    window.addEventListener("message", e)
  }
}

function Et() {
  var t = function () {
      for (var o, r = [
          ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
          ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
          ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
          ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
          ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
        ], a = 0, i = r.length, l = {}; a < i; a++)
        if (o = r[a], o && o[1] in document) {
          for (a = 0; a < o.length; a++) l[r[0][a]] = o[a];
          return l
        } return !1
    }(),
    n = {
      fullscreenchange: t.fullscreenchange,
      fullscreenerror: t.fullscreenerror
    },
    e = {
      request: function (r) {
        return new Promise(function (a, i) {
          var l = function s() {
            e.off("fullscreenchange", s), a()
          };
          e.on("fullscreenchange", l), r = r || document.documentElement;
          var d = r[t.requestFullscreen]();
          d instanceof Promise && d.then(l).catch(i)
        })
      },
      exit: function () {
        return new Promise(function (r, a) {
          if (!e.isFullscreen) {
            r();
            return
          }
          var i = function d() {
            e.off("fullscreenchange", d), r()
          };
          e.on("fullscreenchange", i);
          var l = document[t.exitFullscreen]();
          l instanceof Promise && l.then(i).catch(a)
        })
      },
      on: function (r, a) {
        var i = n[r];
        i && document.addEventListener(i, a)
      },
      off: function (r, a) {
        var i = n[r];
        i && document.removeEventListener(i, a)
      }
    };
  return Object.defineProperties(e, {
    isFullscreen: {
      get: function () {
        return Boolean(document[t.fullscreenElement])
      }
    },
    element: {
      enumerable: !0,
      get: function () {
        return document[t.fullscreenElement]
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function () {
        return Boolean(document[t.fullscreenEnabled])
      }
    }
  }), e
}
var le = new WeakMap,
  $e = new WeakMap,
  Q = {},
  Ie = function () {
    function t(n) {
      var e = this,
        o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (st(this, t), window.jQuery && n instanceof jQuery && (n.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), n = n[0]), typeof document < "u" && typeof n == "string" && (n = document.getElementById(n)), !lt(n)) throw new TypeError("You must pass either a valid element or a valid id.");
      if (n.nodeName !== "IFRAME") {
        var r = n.querySelector("iframe");
        r && (n = r)
      }
      if (n.nodeName === "IFRAME" && !ae(n.getAttribute("src") || "")) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
      if (le.has(n)) return le.get(n);
      this._window = n.ownerDocument.defaultView, this.element = n, this.origin = "*";
      var a = new ne(function (l, d) {
        if (e._onMessage = function (b) {
            if (!(!ae(b.origin) || e.element.contentWindow !== b.source)) {
              e.origin === "*" && (e.origin = b.origin);
              var v = Pe(b.data),
                C = v && v.event === "error",
                _ = C && v.data && v.data.method === "ready";
              if (_) {
                var m = new Error(v.data.message);
                m.name = v.data.name, d(m);
                return
              }
              var w = v && v.event === "ready",
                p = v && v.method === "ping";
              if (w || p) {
                e.element.setAttribute("data-ready", "true"), l();
                return
              }
              vt(e, v)
            }
          }, e._window.addEventListener("message", e._onMessage), e.element.nodeName !== "IFRAME") {
          var s = He(n, o),
            y = Ue(s);
          Qe(y, s, n).then(function (b) {
            var v = qe(b, n);
            return e.element = v, e._originalElement = n, ht(n, v), le.set(e.element, e), b
          }).catch(d)
        }
      });
      if ($e.set(this, a), le.set(this.element, this), this.element.nodeName === "IFRAME" && he(this, "ping"), Q.isEnabled) {
        var i = function () {
          return Q.exit()
        };
        this.fullscreenchangeHandler = function () {
          Q.isFullscreen ? pe(e, "event:exitFullscreen", i) : Ce(e, "event:exitFullscreen", i), e.ready().then(function () {
            he(e, "fullscreenchange", Q.isFullscreen)
          })
        }, Q.on("fullscreenchange", this.fullscreenchangeHandler)
      }
      return this
    }
    return ct(t, [{
      key: "callMethod",
      value: function (e) {
        var o = this,
          r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return new ne(function (a, i) {
          return o.ready().then(function () {
            pe(o, e, {
              resolve: a,
              reject: i
            }), he(o, e, r)
          }).catch(i)
        })
      }
    }, {
      key: "get",
      value: function (e) {
        var o = this;
        return new ne(function (r, a) {
          return e = ze(e, "get"), o.ready().then(function () {
            pe(o, e, {
              resolve: r,
              reject: a
            }), he(o, e)
          }).catch(a)
        })
      }
    }, {
      key: "set",
      value: function (e, o) {
        var r = this;
        return new ne(function (a, i) {
          if (e = ze(e, "set"), o == null) throw new TypeError("There must be a value to set.");
          return r.ready().then(function () {
            pe(r, e, {
              resolve: a,
              reject: i
            }), he(r, e, o)
          }).catch(i)
        })
      }
    }, {
      key: "on",
      value: function (e, o) {
        if (!e) throw new TypeError("You must pass an event name.");
        if (!o) throw new TypeError("You must pass a callback function.");
        if (typeof o != "function") throw new TypeError("The callback must be a function.");
        var r = Se(this, "event:".concat(e));
        r.length === 0 && this.callMethod("addEventListener", e).catch(function () {}), pe(this, "event:".concat(e), o)
      }
    }, {
      key: "off",
      value: function (e, o) {
        if (!e) throw new TypeError("You must pass an event name.");
        if (o && typeof o != "function") throw new TypeError("The callback must be a function.");
        var r = Ce(this, "event:".concat(e), o);
        r && this.callMethod("removeEventListener", e).catch(function (a) {})
      }
    }, {
      key: "loadVideo",
      value: function (e) {
        return this.callMethod("loadVideo", e)
      }
    }, {
      key: "ready",
      value: function () {
        var e = $e.get(this) || new ne(function (o, r) {
          r(new Error("Unknown player. Probably unloaded."))
        });
        return ne.resolve(e)
      }
    }, {
      key: "addCuePoint",
      value: function (e) {
        var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.callMethod("addCuePoint", {
          time: e,
          data: o
        })
      }
    }, {
      key: "removeCuePoint",
      value: function (e) {
        return this.callMethod("removeCuePoint", e)
      }
    }, {
      key: "enableTextTrack",
      value: function (e, o) {
        if (!e) throw new TypeError("You must pass a language.");
        return this.callMethod("enableTextTrack", {
          language: e,
          kind: o
        })
      }
    }, {
      key: "disableTextTrack",
      value: function () {
        return this.callMethod("disableTextTrack")
      }
    }, {
      key: "pause",
      value: function () {
        return this.callMethod("pause")
      }
    }, {
      key: "play",
      value: function () {
        return this.callMethod("play")
      }
    }, {
      key: "requestFullscreen",
      value: function () {
        return Q.isEnabled ? Q.request(this.element) : this.callMethod("requestFullscreen")
      }
    }, {
      key: "exitFullscreen",
      value: function () {
        return Q.isEnabled ? Q.exit() : this.callMethod("exitFullscreen")
      }
    }, {
      key: "getFullscreen",
      value: function () {
        return Q.isEnabled ? ne.resolve(Q.isFullscreen) : this.get("fullscreen")
      }
    }, {
      key: "requestPictureInPicture",
      value: function () {
        return this.callMethod("requestPictureInPicture")
      }
    }, {
      key: "exitPictureInPicture",
      value: function () {
        return this.callMethod("exitPictureInPicture")
      }
    }, {
      key: "getPictureInPicture",
      value: function () {
        return this.get("pictureInPicture")
      }
    }, {
      key: "unload",
      value: function () {
        return this.callMethod("unload")
      }
    }, {
      key: "destroy",
      value: function () {
        var e = this;
        return new ne(function (o) {
          if ($e.delete(e), le.delete(e.element), e._originalElement && (le.delete(e._originalElement), e._originalElement.removeAttribute("data-vimeo-initialized")), e.element && e.element.nodeName === "IFRAME" && e.element.parentNode && (e.element.parentNode.parentNode && e._originalElement && e._originalElement !== e.element.parentNode ? e.element.parentNode.parentNode.removeChild(e.element.parentNode) : e.element.parentNode.removeChild(e.element)), e.element && e.element.nodeName === "DIV" && e.element.parentNode) {
            e.element.removeAttribute("data-vimeo-initialized");
            var r = e.element.querySelector("iframe");
            r && r.parentNode && (r.parentNode.parentNode && e._originalElement && e._originalElement !== r.parentNode ? r.parentNode.parentNode.removeChild(r.parentNode) : r.parentNode.removeChild(r))
          }
          e._window.removeEventListener("message", e._onMessage), Q.isEnabled && Q.off("fullscreenchange", e.fullscreenchangeHandler), o()
        })
      }
    }, {
      key: "getAutopause",
      value: function () {
        return this.get("autopause")
      }
    }, {
      key: "setAutopause",
      value: function (e) {
        return this.set("autopause", e)
      }
    }, {
      key: "getBuffered",
      value: function () {
        return this.get("buffered")
      }
    }, {
      key: "getCameraProps",
      value: function () {
        return this.get("cameraProps")
      }
    }, {
      key: "setCameraProps",
      value: function (e) {
        return this.set("cameraProps", e)
      }
    }, {
      key: "getChapters",
      value: function () {
        return this.get("chapters")
      }
    }, {
      key: "getCurrentChapter",
      value: function () {
        return this.get("currentChapter")
      }
    }, {
      key: "getColor",
      value: function () {
        return this.get("color")
      }
    }, {
      key: "setColor",
      value: function (e) {
        return this.set("color", e)
      }
    }, {
      key: "getCuePoints",
      value: function () {
        return this.get("cuePoints")
      }
    }, {
      key: "getCurrentTime",
      value: function () {
        return this.get("currentTime")
      }
    }, {
      key: "setCurrentTime",
      value: function (e) {
        return this.set("currentTime", e)
      }
    }, {
      key: "getDuration",
      value: function () {
        return this.get("duration")
      }
    }, {
      key: "getEnded",
      value: function () {
        return this.get("ended")
      }
    }, {
      key: "getLoop",
      value: function () {
        return this.get("loop")
      }
    }, {
      key: "setLoop",
      value: function (e) {
        return this.set("loop", e)
      }
    }, {
      key: "setMuted",
      value: function (e) {
        return this.set("muted", e)
      }
    }, {
      key: "getMuted",
      value: function () {
        return this.get("muted")
      }
    }, {
      key: "getPaused",
      value: function () {
        return this.get("paused")
      }
    }, {
      key: "getPlaybackRate",
      value: function () {
        return this.get("playbackRate")
      }
    }, {
      key: "setPlaybackRate",
      value: function (e) {
        return this.set("playbackRate", e)
      }
    }, {
      key: "getPlayed",
      value: function () {
        return this.get("played")
      }
    }, {
      key: "getQualities",
      value: function () {
        return this.get("qualities")
      }
    }, {
      key: "getQuality",
      value: function () {
        return this.get("quality")
      }
    }, {
      key: "setQuality",
      value: function (e) {
        return this.set("quality", e)
      }
    }, {
      key: "getSeekable",
      value: function () {
        return this.get("seekable")
      }
    }, {
      key: "getSeeking",
      value: function () {
        return this.get("seeking")
      }
    }, {
      key: "getTextTracks",
      value: function () {
        return this.get("textTracks")
      }
    }, {
      key: "getVideoEmbedCode",
      value: function () {
        return this.get("videoEmbedCode")
      }
    }, {
      key: "getVideoId",
      value: function () {
        return this.get("videoId")
      }
    }, {
      key: "getVideoTitle",
      value: function () {
        return this.get("videoTitle")
      }
    }, {
      key: "getVideoWidth",
      value: function () {
        return this.get("videoWidth")
      }
    }, {
      key: "getVideoHeight",
      value: function () {
        return this.get("videoHeight")
      }
    }, {
      key: "getVideoUrl",
      value: function () {
        return this.get("videoUrl")
      }
    }, {
      key: "getVolume",
      value: function () {
        return this.get("volume")
      }
    }, {
      key: "setVolume",
      value: function (e) {
        return this.set("volume", e)
      }
    }]), t
  }();
je || (Q = Et(), yt(), bt(), wt(), _t());
var ve = Ie;
var Ae = 650;

function Te(t, n) {
  let e = typeof t.desktop != "string" ? t.desktop.dataset.videoDesktop : document.querySelector(t.desktop).dataset.videoDesktop;
  if (!e || e === "") return;
  R.info(`new ${t.name} VimeoPlayer`);
  let o = t.mobile ? typeof t.mobile != "string" ? t.mobile.dataset.videoMobile : document.querySelector(t.mobile).dataset.videoMobile : void 0,
    r = typeof t.launchBtn != "string" ? t.launchBtn : document.querySelector(t.launchBtn),
    a = t.container ? typeof t.container != "string" ? t.container : document.querySelector(t.container) : document.querySelector("#vimeo-container"),
    i = t.container ? t.container : document.querySelector("#vimeo-mobile"),
    l = t.container ? t.container : document.querySelector("#vimeo-desktop"),
    d = t.container ? void 0 : document.querySelector(".vimeo-modal .vimeo-modal__close-btn"),
    s = t.hideElement ? typeof t.hideElement != "string" ? t.hideElement : document.querySelector(t.hideElement) : void 0,
    y = n || {},
    b, v, C, _ = () => {
      !t.container && a && (C = window.scrollY, a.dataset.show = !0, t.preventBodyScroll && (document.body.dataset.modalMode = !0, document.body.dataset.fixed = !0, document.documentElement.dataset.modalMode = !0)), o && window.innerWidth < Ae ? v = new ve(i, {
        ...y,
        id: o
      }) : b = new ve(l, {
        ...y,
        id: e
      }), s && (s.style.display = "none"), o && window.addEventListener("resize", m)
    },
    m = async () => {
      if (a && a.dataset.show === "false") return;
      let p = 0;
      window.innerWidth < Ae && !v ? (b && (p = await b.getCurrentTime(), b.destroy(), b = null), v = new ve(i, {
        ...y,
        id: o
      }), p && v.setCurrentTime(p)) : window.innerWidth >= Ae && !b && (v && (p = await v.getCurrentTime(), v.destroy(), v = null), b = new ve(l, {
        ...y,
        id: e
      }), p && b.setCurrentTime(p))
    }, w = () => {
      a && (a.dataset.show = !1, t.preventBodyScroll && (document.body.dataset.modalMode = !1, document.body.dataset.fixed = !1, document.documentElement.dataset.modalMode = !1), window.scrollTo({
        left: 0,
        top: C,
        behavior: "auto"
      }), o && window.removeEventListener("resize", m)), b && (b.destroy(), b = null), v && (v.destroy(), v = null)
    };
  r && r.addEventListener("click", _), !t.container && d && d.addEventListener("click", w)
}

function xe() {
  let t = document.querySelector(".theme-redirect-modal"),
    n = !1,
    e = document.querySelector(".theme-redirect-modal-container__close"),
    o = document.querySelectorAll(".muse__store-link"),
    r = document.querySelector(".theme-redirect-modal__overlay"),
    a = document.querySelector("body"),
    i = document.querySelector("html"),
    l = document.querySelectorAll(".theme-redirect-modal__nav-container-nav-item a"),
    d = document.querySelectorAll(".theme-redirect-modal__regions-container-mobile-nav-item a"),
    s = document.querySelectorAll(".theme-redirect-modal__regions-container");
  o.forEach(p => p.addEventListener("click", function () {
    t.classList.add("theme-redirect-modal--active"), r.classList.add("theme-redirect-modal__overlay--active"), a.classList.add("modal--active"), i.classList.add("modal--active"), n = !0
  })), e.addEventListener("click", function () {
    y()
  }), l.forEach(p => {
    p.addEventListener("click", function (c) {
      let u = document.getElementById(p.dataset.id);
      s.forEach(f => {
        f.classList.remove("active_tab")
      }), l.forEach(f => {
        f.classList.remove("active_link")
      }), p.classList.add("active_link"), u.classList.add("active_tab")
    })
  }), d.forEach(p => {
    p.addEventListener("click", function (c) {
      let u = document.getElementById(p.dataset.id);
      s.forEach(f => {
        f.classList.remove("active_tab")
      }), d.forEach(f => {
        f.classList.remove("active_link")
      }), p.classList.add("active_link"), u.classList.add("active_tab")
    })
  }), document.addEventListener("keydown", p => {
    n && p.key === "Escape" && y()
  });

  function y() {
    t.classList.remove("theme-redirect-modal--active"), r.classList.remove("theme-redirect-modal__overlay--active"), a.classList.remove("modal--active"), i.classList.remove("modal--active"), n = !1
  }
  let b = document.querySelectorAll("[data-tab='desktop']"),
    v = document.querySelectorAll("[data-tab='mobile']"),
    C = document.querySelectorAll(".theme-redirect-modal__tab-content"),
    _ = 0,
    m = "theme-redirect-modal__tab--active",
    w = "theme-redirect-modal__tab-content--active";
  b.forEach((p, c) => {
    p.addEventListener("click", () => {
      b[_].classList.toggle(m), b[c].classList.toggle(m), C[_].classList.toggle(w), C[c].classList.toggle(w), _ = c
    })
  }), v.forEach((p, c) => {
    p.addEventListener("click", () => {
      b[_].classList.toggle(m), b[c].classList.toggle(m), C[_].classList.toggle(w), C[c].classList.toggle(w), _ = c
    })
  })
}

function Ne() {
  var t = 0;
  let n = document.querySelector(".theme-redirect-modal"),
    e = !1,
    o = document.querySelector(".theme-redirect-modal__overlay"),
    r = document.querySelector("body"),
    a = document.querySelector("html");

  function i(d, s, y, b) {
    var v = d + "=" + encodeURIComponent(s);
    typeof y == "number" && (v += "; max-age=" + y * 24 * 60 * 60 + ";domain=" + b, document.cookie = v)
  }

  function l(d) {
    for (var s = document.cookie.split(";"), y = 0; y < s.length; y++) {
      var b = s[y].split("=");
      if (d == b[0].trim()) return decodeURIComponent(b[1])
    }
    return null
  }
  window.onload = function () {
    n.classList.contains("theme-redirect-modal--active") && (document.cookie.indexOf("modalShown") == -1 || (t = l("modalShown")), t++, i("modalShown", t, 10, ".choosemuse.com"), l("modalShown") > 2 && (n.classList.remove("theme-redirect-modal--active"), o.classList.remove("theme-redirect-modal__overlay--active"), r.classList.remove("modal--active"), a.classList.remove("modal--active"), e = !1));
    var d = document.querySelector(".navigation__actions").querySelector(".theme-button").getAttribute("href");
    if (document.querySelector(".global-hero__button") != null) var s = document.querySelector(".global-hero__button").querySelector(".theme-button").getAttribute("href");
    var y = ["AT", "BE", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "HU", "IE", "IT", "LV", "LT", "LU", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "GB"],
      b = localStorage.getItem("CPVisitorCountry"),
      v = localStorage.getItem("ip_country"),
      C = !!b ? b : v;
    y.indexOf(C) !== -1 ? (document.querySelector(".navigation__actions").querySelector(".theme-button").setAttribute("href", d.replace("/pages/", "https://eu.choosemuse.com/pages/")), document.querySelector(".global-hero__button") != null && document.querySelector(".global-hero__button").querySelector(".theme-button").setAttribute("href", s.replace("/products/", "https://eu.choosemuse.com/products/")), l("modalShown") > 2 && localStorage.setItem("muse_location", "eu")) : C == "US" ? (document.querySelector(".navigation__actions").querySelector(".theme-button").setAttribute("href", d.replace("/pages/", "https://choosemuse.com/pages/")), document.querySelector(".global-hero__button") != null && document.querySelector(".global-hero__button").querySelector(".theme-button").setAttribute("href", s.replace("/products/", "https://choosemuse.com/products/")), l("modalShown") > 2 && localStorage.setItem("muse_location", "us")) : C == "CA" ? (document.querySelector(".navigation__actions").querySelector(".theme-button").setAttribute("href", d.replace("/pages/", "https://ca.choosemuse.com/pages/")), document.querySelector(".global-hero__button") != null && document.querySelector(".global-hero__button").querySelector(".theme-button").setAttribute("href", s.replace("/products/", "https://ca.choosemuse.com/products/")), l("modalShown") > 2 && localStorage.setItem("muse_location", "ca")) : (document.querySelector(".navigation__actions").querySelector(".theme-button").setAttribute("href", d.replace("/pages/", "https://intl.choosemuse.com/pages/")), document.querySelector(".global-hero__button") != null && document.querySelector(".global-hero__button").querySelector(".theme-button").setAttribute("href", s.replace("/products/", "https://intl.choosemuse.com/products/")), l("modalShown") > 2 && localStorage.setItem("muse_location", "intl"))
  }
}

function Fe() {
  let t = ["eu", "ca", "intl", "us"],
    n = ["/cart", "/checkout", "/products", "/pages/premium-subscription", "/pages/muse-connect", "/pages/compare", "/pages/shop", "/pages/shop-in-bulk", "/pages/shop-accessories"],
    e = window.location,
    o = () => {
      window.location.origin !== "https://sandbox.choosemuse.com" && (r(), v())
    },
    r = () => {
      let m = _("_muse_store"),
        w = _("_muse_store_prev"),
        p = t.find(g => g === m),
        c = y(),
        u = t.find(g => g === c),
        f = d(),
        E = t.find(g => g === f),
        P = new URLSearchParams(window.location.search).get("discount");
      E ? b(f) : u && w != c ? b(c) : p ? b(m) : (b("us"), c = "us"), P && location.hostname === "choosemuse.com" && (t.filter(g => g !== "us").forEach(g => {
        let L = document.createElement("iframe");
        L.setAttribute("src", encodeURI(`https://${g}.choosemuse.com/discount/${P}`)), L.setAttribute("style", "display: none;"), L.setAttribute("id", "discount-iframe"), L.setAttribute("name", "discount-iframe"), document.body.appendChild(L)
      }), setTimeout(() => {
        window.location.href = encodeURI(`https://choosemuse.com/discount/${P}`)
      }, 1e3)), s() ? (c === "choosemuse" && (c = "us"), a(c)) : e.pathname === "/search" && e.hostname !== "choosemuse.com" && i("search", "us")
    },
    a = m => {
      let w = _("_muse_store");
      if (m != w) {
        let p = window.location.pathname.includes("/products"),
          c = l(),
          u = e.pathname;
        c == "cart" ? i("cart", w) : c == "checkout" ? i("checkout", w) : p ? i("products", w) : n.find(f => f == u) && i("page-with-pricing", w)
      }
    },
    i = (m, w) => {
      let p = w === "us" ? "shop" : w,
        c;
      m == "cart" ? c = "/cart" : m == "checkout" ? c = "/checkout" : m == "search" ? c = `/search${window.location.search}` : c = e.pathname, t.includes(p) && location.hostname !== `https://${p}.choosemuse.com${c}` ? window.location.href = `https://${p}.choosemuse.com${c}` : p === "shop" && location.hostname !== "choosemuse.com" && (window.location.href = `https://choosemuse.com${c}`)
    },
    l = () => {
      let m;
      return window.location.pathname == "/cart" ? m = "cart" : window.location.pathname.includes("/checkouts/") && (m = "checkout"), m
    },
    d = () => {
      let m = window.location.search;
      return new URLSearchParams(m).get("force")
    },
    s = () => n.map(m => window.location.pathname.includes(m)).reduce((m, w) => m || w),
    y = () => window.location.host.split(".")[0],
    b = (m, w) => {
      let p, c = document.querySelectorAll("img.header__store-flag"),
        u = document.querySelectorAll("span.header__store-content"),
        f = location.hostname === "localhost" || location.hostname === "127.0.0.1" ? location.hostname : ".choosemuse.com;",
        E = t.map(P => {
          let g = c[0].src.match(`assets/${P}`);
          return g && (p = P), g
        }).reduce((P, g) => P || g),
        k = new Date(Date.now() + 864e5);
      k = k.toUTCString(), document.cookie = `_muse_store=${m}; expires=${k}; path=/; secure; domain=${f}`, p && (document.cookie = `_muse_store_prev=${p}; expires=${k}; path=/; secure; domain=${f}`), w && localStorage.setItem("muse_location", m)
    },
    v = () => {
      document.querySelectorAll(".theme-redirect-modal__tab-country button").forEach(w => {
        w.addEventListener("click", function (p) {
          let c = w.dataset.locationLink;
          b(c, !0), s() && window.location.reload(), C()
        })
      })
    },
    C = () => {
      document.querySelector(".theme-redirect-modal").classList.remove("theme-redirect-modal--active"), document.querySelector("body").classList.remove("modal--active"), document.querySelector("html").classList.remove("modal--active"), document.querySelector(".theme-redirect-modal__overlay").classList.remove("theme-redirect-modal__overlay--active")
    },
    _ = m => {
      let w = document.cookie.match(new RegExp("(?:^|; )" + m.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
      return w ? w[1] : !1
    };
  return o()
}
var ge = class {
  constructor() {
    re(this, "productMap", [{
      handle: "muse-s-gen-2-subscription",
      upsells: [{
        title: "Muse S Case (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/files/MuseSCase_2_6c0d98c2-e1be-4875-a46a-27dff6bf5166.png?v=1684517206",
        us: {
          id: 32189940432999,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        ca: {
          id: 32239675080790,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        eu: {
          id: 32656754311256,
          price: "\u20AC26.99",
          comparePrice: "\u20AC36.99"
        },
        intl: {
          id: 31670323183677,
          price: "$29.99",
          comparePrice: "$39.99"
        }
      }, {
        title: "Muse S (Gen 2) Additional Fabric Band (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/files/Band_9d8d71df-77b2-46a5-90b2-565ec4c64b46.png?v=1684517179",
        us: {
          id: 39496456929383,
          price: "$44.99",
          comparePrice: "$79.99"
        },
        ca: {
          id: 39564182585430,
          price: "$59.99",
          comparePrice: "$99.99"
        },
        eu: {
          id: 39661519863896,
          price: "\u20AC41.99",
          comparePrice: "\u20AC69.99"
        },
        intl: {
          id: 39419457962045,
          price: "$47.99",
          comparePrice: "$79.99"
        }
      }]
    }, {
      handle: "muse-s-gen-2",
      upsells: [{
        title: "Muse S Case (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/files/MuseSCase_2_6c0d98c2-e1be-4875-a46a-27dff6bf5166.png?v=1684517206",
        us: {
          id: 32189940432999,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        ca: {
          id: 32239675080790,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        eu: {
          id: 32656754311256,
          price: "\u20AC26.99",
          comparePrice: "\u20AC36.99"
        },
        intl: {
          id: 31670323183677,
          price: "$29.99",
          comparePrice: "$39.99"
        }
      }, {
        title: "Muse S (Gen 2) Additional Fabric Band (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/files/Band_9d8d71df-77b2-46a5-90b2-565ec4c64b46.png?v=1684517179",
        us: {
          id: 39496456929383,
          price: "$44.99",
          comparePrice: "$79.99"
        },
        ca: {
          id: 39564182585430,
          price: "$59.99",
          comparePrice: "$99.99"
        },
        eu: {
          id: 39661519863896,
          price: "\u20AC41.99",
          comparePrice: "\u20AC69.99"
        },
        intl: {
          id: 39419457962045,
          price: "$47.99",
          comparePrice: "$79.99"
        }
      }, {
        title: "Annual Premium Subscription (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/products/Shopify.png?v=1678287289",
        us: {
          id: 20913367875687,
          price: "$49.99",
          comparePrice: "$94.99"
        },
        ca: {
          id: 28312710840406,
          price: "$68.99",
          comparePrice: "$124.99"
        },
        eu: {
          id: 29651897385048,
          price: "\u20AC39.99",
          comparePrice: "\xA378.99"
        },
        intl: {
          id: 28582379388989,
          price: "$49.99",
          comparePrice: "$94.99"
        }
      }]
    }, {
      handle: "muse-2",
      upsells: [{
        title: "Muse 2 Hard Carrying Case (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/files/Muse2Case.png?v=1684517151",
        us: {
          id: 0xbb93ead0067,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        ca: {
          id: 0xba25dc88056,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        eu: {
          id: 20623451062360,
          price: "\u20AC26.99",
          comparePrice: "\u20AC36.99"
        },
        intl: {
          id: 28564131053629,
          price: "$29.99",
          comparePrice: "$39.99"
        }
      }, {
        title: "Annual Premium Subscription (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/products/Shopify.png?v=1678287289",
        us: {
          id: 20913367875687,
          price: "$49.99",
          comparePrice: "$94.99"
        },
        ca: {
          id: 28312710840406,
          price: "$68.99",
          comparePrice: "$124.99"
        },
        eu: {
          id: 29651897385048,
          price: "\u20AC39.99",
          comparePrice: "\xA378.99"
        },
        intl: {
          id: 28582379388989,
          price: "$49.99",
          comparePrice: "$94.99"
        }
      }]
    }, {
      handle: "muse-2-premium-subscription-bundle",
      upsells: [{
        title: "Muse 2 Hard Carrying Case (Bundled)",
        image: "https://cdn.shopify.com/s/files/1/0348/7053/files/Muse2Case.png?v=1684517151",
        us: {
          id: 0xbb93ead0067,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        ca: {
          id: 0xba25dc88056,
          price: "$29.99",
          comparePrice: "$39.99"
        },
        eu: {
          id: 20623451062360,
          price: "\u20AC26.99",
          comparePrice: "\u20AC36.99"
        },
        intl: {
          id: 28564131053629,
          price: "$29.99",
          comparePrice: "$39.99"
        }
      }]
    }]);
    R.info("Upsell > constructor")
  }
  getProducts(n, e) {
    R.info(`Upsell > getProducts(${n}, ${e})`);
    let o = [],
      r = this.productMap.find(a => a.handle === n);
    return r && r.upsells.forEach(a => {
      let i = {
        title: a.title,
        id: a[e].id,
        price: a[e].price || "Add to cart to see price",
        comparePrice: a[e].comparePrice,
        image: a.image
      };
      o.push(i)
    }), o
  }
  updateView(n, e) {
    if (R.info("Upsell > updateView: products", n), e.childNodes.length)
      for (; e.firstChild;) e.removeChild(e.firstChild);
    n.forEach(o => {
      let r = document.createElement("div");
      r.className = "sidecart__item", r.dataset.lineItemId = o.id;
      let a = document.createElement("div");
      a.className = "sidecart__item__image", o.image && (a.style.backgroundImage = `url(${o.image}&width=130)`), r.appendChild(a);
      let i = document.createElement("div");
      i.className = "sidecart__item__info";
      let l = document.createElement("p");
      l.className = "sidecart__item__info__title", l.textContent = o.title, i.appendChild(l), r.appendChild(i);
      let d = document.createElement("div");
      d.className = "sidecart__item__total";
      let s = document.createElement("p");
      if (s.className = "sidecart__item__total__price", o.comparePrice) {
        let v = document.createElement("span");
        v.textContent = o.comparePrice, v.className = "compare-price", s.appendChild(v)
      }
      let y = document.createElement("span");
      y.textContent = o.price, s.appendChild(y), d.appendChild(s);
      let b = document.createElement("button");
      b.textContent = "add to cart", b.className = "theme-button theme-button--primary theme-button--small", b.type = "button", b.dataset.border = !0, b.dataset.addToCart = !0, b.dataset.product_id = o.id, d.appendChild(b), r.appendChild(d), e.appendChild(r)
    })
  }
};

function De() {
  let t = new ge,
    n = ["eu", "ca", "intl", "us"],
    e = document.getElementsByTagName("head")[0],
    o = document.querySelector("#shopify-section-sidecart"),
    r = o.querySelector(".sidecart__items-wrap"),
    a = o.querySelector(".sidecart__upsell-wrap"),
    i = o.querySelector(".sidecart__header"),
    l = o.querySelector("[data-checkout]"),
    d = o.querySelector("#sidecart-subtotal-price"),
    s = {
      USD: "$",
      CAD: "$",
      EUR: "\u20AC"
    },
    y = o.querySelectorAll("[data-close-sidecart]"),
    b = document.querySelectorAll("[data-add-to-cart]"),
    v = document.querySelectorAll("[data-open-sidecart]"),
    C = "choosemuse.com",
    _, m, w, p, c, u, f = !1,
    E, k;

  function P(h, F = !1) {
    f = !f, R.info(`Sidecart > showToggle; ${f}`), o.dataset.show = f, document.body.dataset.modalMode = f, document.documentElement.dataset.modalMode = f, f && !F && $()
  }

  function g(h) {
    let F = h.target.dataset.lineItemId,
      N = c.find(z => z.dataset.lineItemId == F),
      x = parseInt(N.value);
    x++, M(F, x)
  }

  function L(h) {
    let F = h.target.dataset.lineItemId,
      N = c.find(z => z.dataset.lineItemId == F),
      x = parseInt(N.value);
    x && (x--, M(F, x))
  }

  function D(h) {
    M(h.target.dataset.lineItemId, 0)
  }

  function j(h) {
    M(h.target.dataset.lineItemId, h.target.value)
  }

  function W() {
    m && m.forEach(h => h.removeEventListener("click", D)), w && w.forEach(h => h.removeEventListener("click", g)), p && p.forEach(h => h.removeEventListener("click", L)), c && c.forEach(h => h.removeEventListener("change", j)), b && b.forEach(h => h.removeEventListener("click", A)), m = o.querySelectorAll("[data-remove-from-sidecart]"), w = o.querySelectorAll("[data-line-item-increment]"), p = o.querySelectorAll("[data-line-item-decrement]"), c = Array.from(o.querySelectorAll("[data-line-item-quantity]")), u = Array.from(o.querySelectorAll("[data-line-item-price]")), b = document.querySelectorAll("[data-add-to-cart]"), m.forEach(h => h.addEventListener("click", D)), w.forEach(h => h.addEventListener("click", g)), p.forEach(h => h.addEventListener("click", L)), c.forEach(h => h.addEventListener("change", j)), b.forEach(h => h.addEventListener("click", A))
  }

  function q(h) {
    R.info("Sidecart > updateView");
    let F = [];
    o.querySelectorAll(".sidecart__item").forEach(x => {
      let z = x.dataset.lineItemId;
      h.items.find(J => J.id == z) || x.parentNode.removeChild(x)
    }), h.items.forEach(x => {
      let z = c.find(Y => Y.dataset.lineItemId == x.id),
        J = u.find(Y => Y.dataset.lineItemId == x.id);
      z ? (z.value = x.quantity, J.textContent = `${s[h.currency]}${(x.final_line_price/100).toFixed(2)}`) : T(x, s[h.currency]), F = [...F, ...t.getProducts(x.handle, _)]
    }), Array.from(i.children).forEach(x => x.dataset.cartItemCount = h.item_count), d.textContent = `${s[h.currency]}${(h.total_price/100).toFixed(2)}`, F = [...new Set(F.map(x => JSON.stringify(x)))].map(x => JSON.parse(x)), F = F.filter(x => !h.items.find(z => z.variant_id === x.id)), t.updateView(F, a), W()
  }

  function T(h, F) {
    let N = document.createElement("div");
    N.className = "sidecart__item", N.dataset.lineItemId = h.id;
    let x = document.createElement("div");
    x.className = "sidecart__item__image", h.image && (x.style.backgroundImage = `url(${h.image}&width=130)`), N.appendChild(x);
    let z = document.createElement("div");
    z.className = "sidecart__item__info";
    let J = document.createElement("p");
    J.className = "sidecart__item__info__title", J.textContent = h.title, z.appendChild(J);
    let Y = document.createElement("div");
    Y.className = "sidecart__item__info__quantity-container";
    let ee = document.createElement("button");
    ee.className = "sidecart__item__info__quantity-decrement", ee.type = "button", ee.dataset.lineItemDecrement = !0, ee.dataset.lineItemId = h.id, ee.name = `Remove 1 ${h.title}`, Y.appendChild(ee);
    let te = document.createElement("input");
    te.className = "sidecart__item__info__quantity-input", te.type = "number", te.min = 0, te.setAttribute("aria-label", "Quantity"), te.dataset.lineItemQuantity = h.quantity, te.dataset.lineItemId = h.id, te.value = h.quantity, Y.appendChild(te);
    let ce = document.createElement("button");
    ce.className = "sidecart__item__info__quantity-increment", ce.type = "button", ce.dataset.lineItemIncrement = !0, ce.dataset.lineItemId = h.id, ce.name = `Add 1 ${h.title}`, Y.appendChild(ce), z.appendChild(Y), N.appendChild(z);
    let Ee = document.createElement("div");
    Ee.className = "sidecart__item__total";
    let me = document.createElement("p");
    me.className = "sidecart__item__total__price", me.dataset.lineItemPrice = !0, me.dataset.lineItemId = h.id, me.textContent = `${F}${(h.final_line_price/100).toFixed(2)}`, Ee.appendChild(me);
    let oe = document.createElement("button");
    oe.textContent = "Remove", oe.className = "theme-button theme-button--secondary theme-button--small", oe.type = "button", oe.dataset.border = !0, oe.dataset.removeFromSidecart = !0, oe.dataset.lineItemId = h.id, Ee.appendChild(oe), N.appendChild(Ee), r.appendChild(N)
  }
  async function $() {
    R.info("Sidecart > getCart"), _ = K("_muse_store");
    let h = `${_!=="us"?_+".":""}${C}`;
    if (h === window.location.hostname) {
      let N = await (await fetch("/cart.js")).json();
      q(N)
    } else S(h)
  }

  function S(h) {
    R.info(`Sidecart > getCartJson: ${h}`), E = document.createElement("script"), E.src = `https://${h}/cart.json?callback=cartJsonCallback`, e.appendChild(E)
  }

  function I(h) {
    q(h), e.removeChild(E)
  }
  async function M(h, F) {
    R.info(`Sidecart > updateCart: ${h}, ${F}`), _ = K("_muse_store");
    let N = `${_!=="us"?_+".":""}${C}`;
    if (N === window.location.hostname) {
      let x = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates: {
            [h]: F
          }
        })
      });
      if (x.ok && x.status === 200) {
        let z = await x.json();
        q(z)
      }
    } else {
      let x = `https://${N}/cart/change?id=${h}&quantity=${F}`;
      V(x, N)
    }
  }

  function A(h) {
    B(h.target.dataset.product_id, 1)
  }
  async function B(h, F) {
    R.info(`Sidecart > addToCart: ${h}, ${F}`), _ = K("_muse_store");
    let N = `${_!=="us"?_+".":""}${C}`;
    if (N === window.location.hostname) {
      let x = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: h,
          quantity: F
        })
      });
      x.ok && x.status === 200 && ($(), f || P(null, !0))
    } else {
      let x = `https://${N}/cart/add?id=${h}&quantity=${F||1}`;
      V(x, N)
    }
  }

  function V(h, F) {
    k ? (k.onload = () => S(F), k.setAttribute("src", h)) : O(h, F), setTimeout(() => {
      S(F)
    }, 100)
  }

  function O(h, F) {
    k = document.createElement("iframe"), k.onload = () => S(F), k.setAttribute("src", h), k.setAttribute("style", "display: none;"), k.setAttribute("id", "update-cart-iframe"), k.setAttribute("name", "update-cart-iframe"), o.appendChild(k)
  }

  function U() {
    _ = K("_muse_store"), window.location.href = `https://${_!=="us"?_+".":""}${C}/checkout`
  }

  function K(h) {
    let F = document.cookie.match(new RegExp("(?:^|; )" + h.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
    return F ? F[1] : !1
  }

  function se() {
    R.info("Sidecart > init"), window.cartJsonCallback = I, o.dataset.show = f, document.body.dataset.modalMode = f, document.documentElement.dataset.modalMode = f, l.addEventListener("click", U), y.forEach(h => h.addEventListener("click", P)), b.forEach(h => h.addEventListener("click", A)), v.forEach(h => h.addEventListener("click", P)), W()
  }
  se()
}
var de = "ChatBot";

function Be() {
//   R.info(`${de} > init`);
//   let t = new Date(new Date().toLocaleString("en-US", {
//       timeZone: "America/Toronto"
//     })),
//     n = t.getDay(),
//     e = t.getHours(),
//     o = t.getMinutes();

//   function r() {
//     // R.info(`${de} > init > insertADA`);let i=document.createElement("script");i.setAttribute("id","__ada"),i.setAttribute("data-handle","muse"),i.setAttribute("src","https://static.ada.support/embed2.js"),document.body.appendChild(i)
//   }

//   function a() {
//     R.info(`${de} > init > insertSalesforce`);
//     var i = function (d) {
//       R.info(`${de} > init > insertSalesforce > intESW`);
//       /*
//       embedded_svc.settings.storageDomain = "choosemuse.com", embedded_svc.settings.displayHelpButton = !0, embedded_svc.settings.language = "", embedded_svc.settings.defaultMinimizedText = "Chat With Us!", embedded_svc.settings.disabledMinimizedText = "Offline", embedded_svc.settings.enabledFeatures = ["LiveAgent"], embedded_svc.settings.entryFeature = "LiveAgent", embedded_svc.init("https://choosemuse.my.salesforce.com", "https://choosemuse.my.site.com/", d, "00D41000000g4dE", "Chat_TEST", {
//         baseLiveAgentContentURL: "https://c.la2-c2-ia2.salesforceliveagent.com/content",
//         deploymentId: "57241000000XZBU",
//         buttonId: "5732M000000DB5u",
//         baseLiveAgentURL: "https://d.la2-c2-ia2.salesforceliveagent.com/chat",
//         eswLiveAgentDevName: "Chat_TEST",
//         isOfflineSupportEnabled: !1
//       })
//         */
//     };
//     if (window.embedded_svc) i("https://service.force.com");
//     else {
//       var l = document.createElement("script");
//       l.setAttribute("src", "https://choosemuse.my.salesforce.com/embeddedservice/5.0/esw.min.js"), l.onload = function () {
//         i(null)
//       }, document.body.appendChild(l)
//     }
//   }
//   n <= 5 && e >= 9 && e < 17 ? (R.info(`${de} > init > Within business hours: ${n} ${e} ${o}`), a()) : (R.info(`${de} > init > Outside of business hours: ${n} ${e} ${o}`), r())
}

function Je() {
  let t = "Global";
  R.info(`${t} > loading`);
  let n = document.getElementById("navigationToggle"),
    e = document.getElementById("navigationItems"),
    o = document.querySelector(".navigation__toggle--top"),
    r = document.querySelector(".navigation__toggle--middle"),
    a = document.querySelector(".navigation__toggle--bottom"),
    i = document.querySelector(".navigation__search-icon--image"),
    l = document.querySelector(".navigation__search-form"),
    d = document.querySelector(".global-hero [data-vimeo-ids]"),
    s = document.querySelectorAll("[data-vimeo-ids-fifty]"),
    y = () => {
      if (d && d.dataset.videoDesktop) {
        let m = document.querySelector(".global-hero .video-btn");
        m || (m = document.querySelector(".global-hero .theme-button--icon__play")), Te({
          name: "Hero",
          mobile: d,
          desktop: d,
          launchBtn: m,
          preventBodyScroll: !0
        }, {
          autoplay: !0,
          loop: !1,
          byline: !1,
          controls: !0,
          title: !1,
          responsive: !0
        })
      }
    },
    b = () => {
      s && s.forEach((m, w) => {
        m.dataset.videoDesktop && Te({
          name: `50-50 Video ${w}`,
          desktop: m,
          launchBtn: m.parentNode,
          container: m.parentNode.nextSibling,
          hideElement: m.parentNode
        }, {
          autoplay: !0,
          loop: !1,
          byline: !1,
          controls: !0,
          title: !1,
          responsive: !0,
          playsinline: !0
        })
      })
    },
    v = () => {
      let m = document.querySelectorAll("[data-shopify-hosted-video][data-has-video=true] .video-btn-wrap");
      m && m.forEach((w, p) => {
        let c = w.previousElementSibling;
        c.addEventListener("playing", () => w.dataset.playing = !0), c.addEventListener("pause", () => w.dataset.playing = !1), c.addEventListener("ended", () => {
          w.dataset.playing = !1, c.load()
        }), w.addEventListener("click", () => {
          c.paused ? c.play() : c.pause()
        })
      })
    },
    C = ["/pages/muse-s-gen2", "/pages/muse-s-gen2-offer", "/pages/muse-s-muse2", "/pages/training-wheels-for-meditation"];

  function _() {
    if (R.info(`${t} > init`), !C.includes(window.location.pathname)) {
      Be(), De(), xe(), Ne(), Fe(), y(), b(), v(), n.addEventListener("click", () => {
        e.classList.toggle("navigation__items--show"), o.classList.toggle("navigation__toggle--top-close"), r.classList.toggle("navigation__toggle--middle-close"), a.classList.toggle("navigation__toggle--bottom-close")
      });
      let m = () => {
        window.innerWidth >= 960 && (e.classList.remove("navigation__items--show"), o.classList.remove("navigation__toggle--top-close"), r.classList.remove("navigation__toggle--middle-close"), a.classList.remove("navigation__toggle--bottom-close"))
      };
      i.addEventListener("click", () => {
        l.classList.toggle("navigation__search-form--hide")
      }), window.onresize = m
    }
  }
  R.info(`${t} > loaded`), _()
}
var fe = function () {
  return fe = Object.assign || function (t) {
    for (var n, e = 1, o = arguments.length; e < o; e++)
      for (var r in n = arguments[e]) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    return t
  }, fe.apply(this, arguments)
};

function Ze(t, n, e) {
  if (e || arguments.length === 2)
    for (var o, r = 0, a = n.length; r < a; r++) !o && r in n || (o || (o = Array.prototype.slice.call(n, 0, r)), o[r] = n[r]);
  return t.concat(o || Array.prototype.slice.call(n))
}

function Ye(t) {
  return Array.prototype.slice.call(t)
}

function Ge(t, n) {
  var e = Math.floor(t);
  return e === n || e + 1 === n ? t : n
}

function Xe() {
  return Date.now()
}

function Ve(t, n, e) {
  if (n = "data-keen-slider-" + n, e === null) return t.removeAttribute(n);
  t.setAttribute(n, e || "")
}

function Me(t, n) {
  return n = n || document, typeof t == "function" && (t = t(n)), Array.isArray(t) ? t : typeof t == "string" ? Ye(n.querySelectorAll(t)) : t instanceof HTMLElement ? [t] : t instanceof NodeList ? Ye(t) : []
}

function ye(t) {
  t.raw && (t = t.raw), t.cancelable && !t.defaultPrevented && t.preventDefault()
}

function be(t) {
  t.raw && (t = t.raw), t.stopPropagation && t.stopPropagation()
}

function et() {
  var t = [];
  return {
    add: function (n, e, o, r) {
      n.addListener ? n.addListener(o) : n.addEventListener(e, o, r), t.push([n, e, o, r])
    },
    input: function (n, e, o, r) {
      this.add(n, e, function (a) {
        return function (i) {
          i.nativeEvent && (i = i.nativeEvent);
          var l = i.changedTouches || [],
            d = i.targetTouches || [],
            s = i.detail && i.detail.x ? i.detail : null;
          return a({
            id: s ? s.identifier ? s.identifier : "i" : d[0] ? d[0] ? d[0].identifier : "e" : "d",
            idChanged: s ? s.identifier ? s.identifier : "i" : l[0] ? l[0] ? l[0].identifier : "e" : "d",
            raw: i,
            x: s && s.x ? s.x : d[0] ? d[0].screenX : s ? s.x : i.pageX,
            y: s && s.y ? s.y : d[0] ? d[0].screenY : s ? s.y : i.pageY
          })
        }
      }(o), r)
    },
    purge: function () {
      t.forEach(function (n) {
        n[0].removeListener ? n[0].removeListener(n[2]) : n[0].removeEventListener(n[1], n[2], n[3])
      }), t = []
    }
  }
}

function Re(t, n, e) {
  return Math.min(Math.max(t, n), e)
}

function X(t) {
  return (t > 0 ? 1 : 0) - (t < 0 ? 1 : 0) || +t
}

function Ke(t) {
  var n = t.getBoundingClientRect();
  return {
    height: Ge(n.height, t.offsetHeight),
    width: Ge(n.width, t.offsetWidth)
  }
}

function H(t, n, e, o) {
  var r = t && t[n];
  return r == null ? e : o && typeof r == "function" ? r() : r
}

function G(t) {
  return Math.round(1e6 * t) / 1e6
}

function kt(t) {
  var n, e, o, r, a, i;

  function l(v) {
    i || (i = v), d(!0);
    var C = v - i;
    C > o && (C = o);
    var _ = r[e];
    if (_[3] < C) return e++, l(v);
    var m = _[2],
      w = _[4],
      p = _[0],
      c = _[1] * (0, _[5])(w === 0 ? 1 : (C - m) / w);
    if (c && t.track.to(p + c), C < o) return y();
    i = null, d(!1), s(null), t.emit("animationEnded")
  }

  function d(v) {
    n.active = v
  }

  function s(v) {
    n.targetIdx = v
  }

  function y() {
    var v;
    v = l, a = window.requestAnimationFrame(v)
  }

  function b() {
    var v;
    v = a, window.cancelAnimationFrame(v), d(!1), s(null), i && t.emit("animationStopped"), i = null
  }
  return n = {
    active: !1,
    start: function (v) {
      if (b(), t.track.details) {
        var C = 0,
          _ = t.track.details.position;
        e = 0, o = 0, r = v.map(function (m) {
          var w, p = Number(_),
            c = (w = m.earlyExit) !== null && w !== void 0 ? w : m.duration,
            u = m.easing,
            f = m.distance * u(c / m.duration) || 0;
          _ += f;
          var E = o;
          return o += c, C += f, [p, m.distance, E, o, m.duration, u]
        }), s(t.track.distToIdx(C)), y(), t.emit("animationStarted")
      }
    },
    stop: b,
    targetIdx: null
  }
}

function St(t) {
  var n, e, o, r, a, i, l, d, s, y, b, v, C, _, m = 1 / 0,
    w = [],
    p = null,
    c = 0;

  function u(T) {
    W(c + T)
  }

  function f(T) {
    var $ = E(c + T).abs;
    return g($) ? $ : null
  }

  function E(T) {
    var $ = Math.floor(Math.abs(G(T / e))),
      S = G((T % e + e) % e);
    S === e && (S = 0);
    var I = X(T),
      M = l.indexOf(Ze([], l, !0).reduce(function (B, V) {
        return Math.abs(V - S) < Math.abs(B - S) ? V : B
      })),
      A = M;
    return I < 0 && $++, M === i && (A = 0, $ += I > 0 ? 1 : -1), {
      abs: A + $ * i * I,
      origin: M,
      rel: A
    }
  }

  function k(T, $, S) {
    var I;
    if ($ || !D()) return P(T, S);
    if (!g(T)) return null;
    var M = E(S ?? c),
      A = M.abs,
      B = T - M.rel,
      V = A + B;
    I = P(V);
    var O = P(V - i * X(B));
    return (O !== null && Math.abs(O) < Math.abs(I) || I === null) && (I = O), G(I)
  }

  function P(T, $) {
    if ($ == null && ($ = G(c)), !g(T) || T === null) return null;
    T = Math.round(T);
    var S = E($),
      I = S.abs,
      M = S.rel,
      A = S.origin,
      B = j(T),
      V = ($ % e + e) % e,
      O = l[A],
      U = Math.floor((T - (I - M)) / i) * e;
    return G(O - V - O + l[B] + U + (A === i ? e : 0))
  }

  function g(T) {
    return L(T) === T
  }

  function L(T) {
    return Re(T, s, y)
  }

  function D() {
    return r.loop
  }

  function j(T) {
    return (T % i + i) % i
  }

  function W(T) {
    var $;
    $ = T - c, w.push({
      distance: $,
      timestamp: Xe()
    }), w.length > 6 && (w = w.slice(-6)), c = G(T);
    var S = q().abs;
    if (S !== p) {
      var I = p !== null;
      p = S, I && t.emit("slideChanged")
    }
  }

  function q(T) {
    var $ = T ? null : function () {
      if (i) {
        var S = D(),
          I = S ? (c % e + e) % e : c,
          M = (S ? c % e : c) - a[0][2],
          A = 0 - (M < 0 && S ? e - Math.abs(M) : M),
          B = 0,
          V = E(c),
          O = V.abs,
          U = V.rel,
          K = a[U][2],
          se = a.map(function (h, F) {
            var N = A + B;
            (N < 0 - h[0] || N > 1) && (N += (Math.abs(N) > e - 1 && S ? e : 0) * X(-N));
            var x = F - U,
              z = X(x),
              J = x + O;
            S && (z === -1 && N > K && (J += i), z === 1 && N < K && (J -= i), b !== null && J < b && (N += e), v !== null && J > v && (N -= e));
            var Y = N + h[0] + h[1],
              ee = Math.max(N >= 0 && Y <= 1 ? 1 : Y < 0 || N > 1 ? 0 : N < 0 ? Math.min(1, (h[0] + N) / h[0]) : (1 - N) / h[0], 0);
            return B += h[0] + h[1], {
              abs: J,
              distance: r.rtl ? -1 * N + 1 - h[0] : N,
              portion: ee,
              size: h[0]
            }
          });
        return O = L(O), U = j(O), {
          abs: L(O),
          length: o,
          max: _,
          maxIdx: y,
          min: C,
          minIdx: s,
          position: c,
          progress: S ? I / e : c / o,
          rel: U,
          slides: se,
          slidesLength: e
        }
      }
    }();
    return n.details = $, t.emit("detailsChanged"), $
  }
  return n = {
    absToRel: j,
    add: u,
    details: null,
    distToIdx: f,
    idxToDist: k,
    init: function (T) {
      if (function () {
          if (r = t.options, a = (r.trackConfig || []).map(function (M) {
              return [H(M, "size", 1), H(M, "spacing", 0), H(M, "origin", 0)]
            }), i = a.length) {
            e = G(a.reduce(function (M, A) {
              return M + A[0] + A[1]
            }, 0));
            var S, I = i - 1;
            o = G(e + a[0][2] - a[I][0] - a[I][2] - a[I][1]), l = a.reduce(function (M, A) {
              if (!M) return [0];
              var B = a[M.length - 1],
                V = M[M.length - 1] + (B[0] + B[2]) + B[1];
              return V -= A[2], M[M.length - 1] > V && (V = M[M.length - 1]), V = G(V), M.push(V), (!S || S < V) && (d = M.length - 1), S = V, M
            }, null), o === 0 && (d = 0), l.push(G(e))
          }
        }(), !i) return q(!0);
      var $;
      (function () {
        var S = t.options.range,
          I = t.options.loop;
        b = s = I ? H(I, "min", -1 / 0) : 0, v = y = I ? H(I, "max", m) : d;
        var M = H(S, "min", null),
          A = H(S, "max", null);
        M && (s = M), A && (y = A), C = s === -1 / 0 ? s : t.track.idxToDist(s || 0, !0, 0), _ = y === m ? y : k(y, !0, 0), A === null && (v = y), H(S, "align", !1) && y !== m && a[j(y)][2] === 0 && (_ -= 1 - a[j(y)][0], y = f(_ - c)), C = G(C), _ = G(_)
      })(), $ = T, Number($) === $ ? u(P(L(T))) : q()
    },
    to: W,
    velocity: function () {
      var T = Xe(),
        $ = w.reduce(function (S, I) {
          var M = I.distance,
            A = I.timestamp;
          return T - A > 200 || (X(M) !== X(S.distance) && S.distance && (S = {
            distance: 0,
            lastTimestamp: 0,
            time: 0
          }), S.time && (S.distance += M), S.lastTimestamp && (S.time += A - S.lastTimestamp), S.lastTimestamp = A), S
        }, {
          distance: 0,
          lastTimestamp: 0,
          time: 0
        });
      return $.distance / $.time || 0
    }
  }
}

function Ct(t) {
  var n, e, o, r, a, i, l, d;

  function s(p) {
    return 2 * p
  }

  function y(p) {
    return Re(p, l, d)
  }

  function b(p) {
    return 1 - Math.pow(1 - p, 3)
  }

  function v() {
    return o ? t.track.velocity() : 0
  }

  function C() {
    w();
    var p = t.options.mode === "free-snap",
      c = t.track,
      u = v();
    r = X(u);
    var f = t.track.details,
      E = [];
    if (u || !p) {
      var k = _(u),
        P = k.dist,
        g = k.dur;
      if (g = s(g), P *= r, p) {
        var L = c.idxToDist(c.distToIdx(P), !0);
        L && (P = L)
      }
      E.push({
        distance: P,
        duration: g,
        easing: b
      });
      var D = f.position,
        j = D + P;
      if (j < a || j > i) {
        var W = j < a ? a - D : i - D,
          q = 0,
          T = u;
        if (X(W) === r) {
          var $ = Math.min(Math.abs(W) / Math.abs(P), 1),
            S = function (A) {
              return 1 - Math.pow(1 - A, 1 / 3)
            }($) * g;
          E[0].earlyExit = S, T = u * (1 - $)
        } else E[0].earlyExit = 0, q += W;
        var I = _(T, 100),
          M = I.dist * r;
        t.options.rubberband && (E.push({
          distance: M,
          duration: s(I.dur),
          easing: b
        }), E.push({
          distance: -M + q,
          duration: 500,
          easing: b
        }))
      }
      t.animator.start(E)
    } else t.moveToIdx(y(f.abs), !0, {
      duration: 500,
      easing: function (A) {
        return 1 + --A * A * A * A * A
      }
    })
  }

  function _(p, c) {
    c === void 0 && (c = 1e3);
    var u = 147e-9 + (p = Math.abs(p)) / c;
    return {
      dist: Math.pow(p, 2) / u,
      dur: p / u
    }
  }

  function m() {
    var p = t.track.details;
    p && (a = p.min, i = p.max, l = p.minIdx, d = p.maxIdx)
  }

  function w() {
    t.animator.stop()
  }
  t.on("updated", m), t.on("optionsChanged", m), t.on("created", m), t.on("dragStarted", function () {
    o = !1, w(), n = e = t.track.details.abs
  }), t.on("dragChecked", function () {
    o = !0
  }), t.on("dragEnded", function () {
    var p = t.options.mode;
    p === "snap" && function () {
      var c = t.track,
        u = t.track.details,
        f = u.position,
        E = X(v());
      (f > i || f < a) && (E = 0);
      var k = n + E;
      u.slides[c.absToRel(k)].portion === 0 && (k -= E), n !== e && (k = e), X(c.idxToDist(k, !0)) !== E && (k += E), k = y(k);
      var P = c.idxToDist(k, !0);
      t.animator.start([{
        distance: P,
        duration: 500,
        easing: function (g) {
          return 1 + --g * g * g * g * g
        }
      }])
    }(), p !== "free" && p !== "free-snap" || C()
  }), t.on("dragged", function () {
    e = t.track.details.abs
  })
}

function Pt(t) {
  var n, e, o, r, a, i, l, d, s, y, b, v, C, _, m, w, p, c, u = et();

  function f(q) {
    if (i && d === q.id) {
      var T = g(q);
      if (s) {
        if (!P(q)) return k(q);
        y = T, s = !1, t.emit("dragChecked")
      }
      if (w) return y = T;
      ye(q);
      var $ = function (I) {
        if (p === -1 / 0 && c === 1 / 0) return I;
        var M = t.track.details,
          A = M.length,
          B = M.position,
          V = Re(I, p - B, c - B);
        if (A === 0) return 0;
        if (!t.options.rubberband) return V;
        if (B <= c && B >= p || B < p && e > 0 || B > c && e < 0) return I;
        var O = (B < p ? B - p : B - c) / A,
          U = r * A,
          K = Math.abs(O * U),
          se = Math.max(0, 1 - K / a * 2);
        return se * se * I
      }(l(y - T) / r * o);
      e = X($);
      var S = t.track.details.position;
      (S > p && S < c || S === p && e > 0 || S === c && e < 0) && be(q), b += $, !v && Math.abs(b * r) > 5 && (v = !0), t.track.add($), y = T, t.emit("dragged")
    }
  }

  function E(q) {
    !i && t.track.details && t.track.details.length && (b = 0, i = !0, v = !1, s = !0, d = q.id, P(q), y = g(q), t.emit("dragStarted"))
  }

  function k(q) {
    i && d === q.idChanged && (i = !1, t.emit("dragEnded"))
  }

  function P(q) {
    var T = L(),
      $ = T ? q.y : q.x,
      S = T ? q.x : q.y,
      I = C !== void 0 && _ !== void 0 && Math.abs(_ - S) <= Math.abs(C - $);
    return C = $, _ = S, I
  }

  function g(q) {
    return L() ? q.y : q.x
  }

  function L() {
    return t.options.vertical
  }

  function D() {
    r = t.size, a = L() ? window.innerHeight : window.innerWidth;
    var q = t.track.details;
    q && (p = q.min, c = q.max)
  }

  function j(q) {
    v && (be(q), ye(q))
  }

  function W() {
    if (u.purge(), t.options.drag && !t.options.disabled) {
      var q;
      q = t.options.dragSpeed || 1, l = typeof q == "function" ? q : function ($) {
          return $ * q
        }, o = t.options.rtl ? -1 : 1, D(), n = t.container,
        function () {
          var $ = "data-keen-slider-clickable";
          Me("[".concat($, "]:not([").concat($, "=false])"), n).map(function (S) {
            u.add(S, "dragstart", be), u.add(S, "mousedown", be), u.add(S, "touchstart", be)
          })
        }(), u.add(n, "dragstart", function ($) {
          ye($)
        }), u.add(n, "click", j, {
          capture: !0
        }), u.input(n, "ksDragStart", E), u.input(n, "ksDrag", f), u.input(n, "ksDragEnd", k), u.input(n, "mousedown", E), u.input(n, "mousemove", f), u.input(n, "mouseleave", k), u.input(n, "mouseup", k), u.input(n, "touchstart", E, {
          passive: !0
        }), u.input(n, "touchmove", f, {
          passive: !1
        }), u.input(n, "touchend", k), u.input(n, "touchcancel", k), u.add(window, "wheel", function ($) {
          i && ye($)
        });
      var T = "data-keen-slider-scrollable";
      Me("[".concat(T, "]:not([").concat(T, "=false])"), t.container).map(function ($) {
        return function (S) {
          var I;
          u.input(S, "touchstart", function (M) {
            I = g(M), w = !0, m = !0
          }, {
            passive: !0
          }), u.input(S, "touchmove", function (M) {
            var A = L(),
              B = A ? S.scrollHeight - S.clientHeight : S.scrollWidth - S.clientWidth,
              V = I - g(M),
              O = A ? S.scrollTop : S.scrollLeft,
              U = A && S.style.overflowY === "scroll" || !A && S.style.overflowX === "scroll";
            if (I = g(M), (V < 0 && O > 0 || V > 0 && O < B) && m && U) return w = !0;
            m = !1, ye(M), w = !1
          }), u.input(S, "touchend", function () {
            w = !1
          })
        }($)
      })
    }
  }
  t.on("updated", D), t.on("optionsChanged", W), t.on("created", W), t.on("destroyed", u.purge)
}

function Tt(t) {
  var n, e, o = null;

  function r(C, _, m) {
    t.animator.active ? i(C, _, m) : requestAnimationFrame(function () {
      return i(C, _, m)
    })
  }

  function a() {
    r(!1, !1, e)
  }

  function i(C, _, m) {
    var w = 0,
      p = t.size,
      c = t.track.details;
    if (c && n) {
      var u = c.slides;
      n.forEach(function (f, E) {
        if (C) !o && _ && d(f, null, m), s(f, null, m);
        else {
          if (!u[E]) return;
          var k = u[E].size * p;
          !o && _ && d(f, k, m), s(f, u[E].distance * p - w, m), w += k
        }
      })
    }
  }

  function l(C) {
    return t.options.renderMode === "performance" ? Math.round(C) : C
  }

  function d(C, _, m) {
    var w = m ? "height" : "width";
    _ !== null && (_ = l(_) + "px"), C.style["min-" + w] = _, C.style["max-" + w] = _
  }

  function s(C, _, m) {
    if (_ !== null) {
      _ = l(_);
      var w = m ? _ : 0;
      _ = "translate3d(".concat(m ? 0 : _, "px, ").concat(w, "px, 0)")
    }
    C.style.transform = _, C.style["-webkit-transform"] = _
  }

  function y() {
    n && (i(!0, !0, e), n = null), t.on("detailsChanged", a, !0)
  }

  function b() {
    r(!1, !0, e)
  }

  function v() {
    y(), e = t.options.vertical, t.options.disabled || t.options.renderMode === "custom" || (o = H(t.options.slides, "perView", null) === "auto", t.on("detailsChanged", a), (n = t.slides).length && b())
  }
  t.on("created", v), t.on("optionsChanged", v), t.on("beforeOptionsChanged", function () {
    y()
  }), t.on("updated", b), t.on("destroyed", y)
}

function Mt(t, n) {
  return function (e) {
    var o, r, a, i, l, d, s = et();

    function y(g) {
      var L;
      Ve(e.container, "reverse", (L = e.container, window.getComputedStyle(L, null).getPropertyValue("direction") !== "rtl" || g ? null : "")), Ve(e.container, "v", e.options.vertical && !g ? "" : null), Ve(e.container, "disabled", e.options.disabled && !g ? "" : null)
    }

    function b() {
      v() && p()
    }

    function v() {
      var g = null;
      if (i.forEach(function (D) {
          D.matches && (g = D.__media)
        }), g === o) return !1;
      o || e.emit("beforeOptionsChanged"), o = g;
      var L = g ? a.breakpoints[g] : a;
      return e.options = fe(fe({}, a), L), y(), k(), P(), u(), !0
    }

    function C(g) {
      var L = Ke(g);
      return (e.options.vertical ? L.height : L.width) / e.size || 1
    }

    function _() {
      return e.options.trackConfig.length
    }

    function m(g) {
      for (var L in o = !1, a = fe(fe({}, n), g), s.purge(), r = e.size, i = [], a.breakpoints || []) {
        var D = window.matchMedia(L);
        D.__media = L, i.push(D), s.add(D, "change", b)
      }
      s.add(window, "orientationchange", E), s.add(window, "resize", f), v()
    }

    function w(g) {
      e.animator.stop();
      var L = e.track.details;
      e.track.init(g ?? (L ? L.abs : 0))
    }

    function p(g) {
      w(g), e.emit("optionsChanged")
    }

    function c(g, L) {
      if (g) return m(g), void p(L);
      k(), P();
      var D = _();
      u(), _() !== D ? p(L) : w(L), e.emit("updated")
    }

    function u() {
      var g = e.options.slides;
      if (typeof g == "function") return e.options.trackConfig = g(e.size, e.slides);
      for (var L = e.slides, D = L.length, j = typeof g == "number" ? g : H(g, "number", D, !0), W = [], q = H(g, "perView", 1, !0), T = H(g, "spacing", 0, !0) / e.size || 0, $ = q === "auto" ? T : T / q, S = H(g, "origin", "auto"), I = 0, M = 0; M < j; M++) {
        var A = q === "auto" ? C(L[M]) : 1 / q - T + $,
          B = S === "center" ? .5 - A / 2 : S === "auto" ? 0 : S;
        W.push({
          origin: B,
          size: A,
          spacing: T
        }), I += A
      }
      if (I += T * (j - 1), S === "auto" && !e.options.loop && q !== 1) {
        var V = 0;
        W.map(function (O) {
          var U = I - V;
          return V += O.size + T, U >= 1 || (O.origin = 1 - U - (I > 1 ? 0 : 1 - I)), O
        })
      }
      e.options.trackConfig = W
    }

    function f() {
      k();
      var g = e.size;
      e.options.disabled || g === r || (r = g, c())
    }

    function E() {
      f(), setTimeout(f, 500), setTimeout(f, 2e3)
    }

    function k() {
      var g = Ke(e.container);
      e.size = (e.options.vertical ? g.height : g.width) || 1
    }

    function P() {
      e.slides = Me(e.options.selector, e.container)
    }
    e.container = (d = Me(t, l || document)).length ? d[0] : null, e.destroy = function () {
      s.purge(), e.emit("destroyed"), y(!0)
    }, e.prev = function () {
      e.moveToIdx(e.track.details.abs - 1, !0)
    }, e.next = function () {
      e.moveToIdx(e.track.details.abs + 1, !0)
    }, e.update = c, m(e.options)
  }
}
var Le = function (t, n, e) {
  try {
    return function (o, r) {
      var a, i = {};
      return a = {
          emit: function (l) {
            i[l] && i[l].forEach(function (s) {
              s(a)
            });
            var d = a.options && a.options[l];
            d && d(a)
          },
          moveToIdx: function (l, d, s) {
            var y = a.track.idxToDist(l, d);
            if (y) {
              var b = a.options.defaultAnimation;
              a.animator.start([{
                distance: y,
                duration: H(s || b, "duration", 500),
                easing: H(s || b, "easing", function (v) {
                  return 1 + --v * v * v * v * v
                })
              }])
            }
          },
          on: function (l, d, s) {
            s === void 0 && (s = !1), i[l] || (i[l] = []);
            var y = i[l].indexOf(d);
            y > -1 ? s && delete i[l][y] : s || i[l].push(d)
          },
          options: o
        },
        function () {
          if (a.track = St(a), a.animator = kt(a), r)
            for (var l = 0, d = r; l < d.length; l++)(0, d[l])(a);
          a.track.init(a.options.initial || 0), a.emit("created")
        }(), a
    }(n, Ze([Mt(t, {
      drag: !0,
      mode: "snap",
      renderMode: "precision",
      rubberband: !0,
      selector: ".keen-slider__slide"
    }), Tt, Pt, Ct], e || [], !0))
  } catch (o) {
    console.error(o)
  }
};
var we, Lt = t => {
    we = document.querySelectorAll(".global-steps__slider-controls .slider-controls__dot"), we.forEach((o, r) => o.dataset.index = r), we[0].dataset.active = !0;
    let n = document.querySelector(".global-steps__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=left]"),
      e = document.querySelector(".global-steps__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=right]");
    n.addEventListener("click", t.prev), e.addEventListener("click", t.next), t.on("slideChanged", $t)
  },
  $t = t => {
    we.forEach(n => n.dataset.active = !1), we[t.track.details.rel].dataset.active = !0
  };

function tt() {
  document.getElementById("global-steps-slider") && new Le("#global-steps-slider", {
    loop: !0,
    slides: {
      perView: 1,
      spacing: 16
    },
    breakpoints: {
      "(min-width: 768px)": {
        slides: {
          perView: 2
        }
      },
      "(min-width: 992px)": {
        disabled: !0
      }
    }
  }, [Lt])
}
var _e, qt = t => {
    _e = document.querySelectorAll(".global-reviews__slider-controls .slider-controls__dot"), _e.forEach((a, i) => a.dataset.index = i), _e[0].dataset.active = !0;
    let n = document.querySelector(".global-reviews__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=left]"),
      e = document.querySelector(".global-reviews__alt-slider-controls .circle-arrow-btn[data-dir=left]"),
      o = document.querySelector(".global-reviews__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=right]"),
      r = document.querySelector(".global-reviews__alt-slider-controls .circle-arrow-btn[data-dir=right]");
    n.addEventListener("click", t.prev), e.addEventListener("click", t.prev), o.addEventListener("click", t.next), r.addEventListener("click", t.next), t.on("slideChanged", It)
  },
  It = t => {
    _e.forEach(n => n.dataset.active = !1), _e[t.track.details.rel].dataset.active = !0
  };

function nt() {
  document.querySelector("[data-global-reviews-carousel]") && new Le("[data-global-reviews-carousel]", {
    loop: !0,
    slides: {
      perView: 1,
      spacing: 24
    },
    breakpoints: {
      "(min-width: 540px)": {
        slides: {
          perView: 2
        }
      },
      "(min-width: 860px)": {
        slides: {
          perView: 3,
          spacing: 44
        }
      }
    }
  }, [qt])
}

function ot() {
  let t = document.querySelectorAll(".global-audios__wrapper");
  if (!t.length) return;
  let n = document.querySelectorAll(".global-audios"),
    e = document.querySelectorAll(".global-audios__play"),
    o = [],
    r = (i, l) => {
      let d = i;
      if (d.classList.contains("global-guided-meditations__play-btn") && (d = i.parentNode.querySelector(".play-btn")), d.dataset.playing = l, d.classList.contains("play-btn")) {
        let s = d.dataset.heading || "Audio";
        d.title = l ? `Pause ${s}` : `Play ${s}`, d.ariaLabel = l ? `Pause ${s}` : `Play ${s}`
      }
    },
    a = new IntersectionObserver(i => {
      i.forEach(l => {
        let d = l.isIntersecting;
        o.forEach((s, y) => {
          d === !1 && (s.pause(), s.currentTime = 0, r(e[y], !1))
        })
      })
    });
  n.forEach(i => {
    a.observe(i)
  }), t.forEach((i, l) => {
    o.push(new Audio(i.getAttribute("data-audio-meditation"))), o[l].setAttribute("type", "audio/mpeg"), o[l].setAttribute("preload", "metadata"), o[l].addEventListener("ended", () => {
      r(e[l], !1)
    }), e[l].addEventListener("click", () => {
      o.forEach((d, s) => {
        s !== l && (d.pause(), d.currentTime = 0, r(e[s], !1))
      }), o[l].paused ? o[l].play() : o[l].pause(), o[l].currentTime = 0, r(e[l], !o[l].paused)
    })
  })
}
var rt = "Index",
  At = () => {
    R.log(`${rt} > loaded`), tt(), nt(), ot()
  };
Je();
At();
R.log(`${rt} > loaded`);
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
/*! @vimeo/player v2.18.0 | (c) 2022 Vimeo | MIT License | https://github.com/vimeo/player.js */
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/
//# sourceMappingURL=page-how-it-works.js.map